import Icon from "react-native-vector-icons/MaterialIcons";

export default function IconMaterial(props) {
    return <Icon
        {...props}
    />
}